import axios from 'axios';
import lib from '@/lib';

export default class WorldMapModel {
	constructor() {
		
	}
	
	async moveAdmItem(params = {}) {
		try {
			const response = await axios.post('/api/mapdataadm/move', params, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	// actions
	actPendingAjaxRequest() {
		this.pendingAjaxRequestOpen = true;
		setTimeout(() => {
			this.pendingAjaxRequestOpen = false;
		}, 1000);
	}
}
